export default __webpack_public_path__ + "static/media/lock.da0ef2f6.svg";